import React from 'react';
import clsx from 'clsx';

import './index.scss';

import BasicCheckBoxInput from 'components/atoms/Input/BasicCheckBoxInput';
import RequiredOrOptionalIcon from 'components/atoms/Icon/RequiredOrOptionalIcon';
import TextAreaInput from 'components/atoms/Input/TextAreaInput';
import PcErrorArea from 'components/molecules/PcErrorArea';

const SpAccordionTextArea = ({
  // checkbox
  value,
  label,
  checkBoxOnChange,
  checked,
  id,
  // textarea
  textAreaTitle,
  textAreaLabel,
  name,
  textAreaValue,
  cmntOnChange,
  onInput,
  onCompositionEnd,
  maxLength,
  placeholder,
  rows,
  cols,
  // エラー
  inValid,
  errPosition,
  errMessage,
  // 文字数
  wordCount,
}) =>{
  return(
    <div className="SpAccordionTextArea">
      <div className="sp-accordion-text-area-wrapper">
        <BasicCheckBoxInput 
          value={value}
          onChange={checkBoxOnChange}
          checked={checked}
          label={label}
          id={id}
        />
        <div className={clsx('sp-cmnt-area', { checked })}>
          <div className="arrowArea">
            <div className="sp-background-cmnt" />
          </div>
          <div className="spCollpseAreaBackground">
            <div>
              <span className="title">{textAreaTitle} </span>
              <RequiredOrOptionalIcon label={textAreaLabel} />
            </div>
            <TextAreaInput
              name={name}
              value={textAreaValue}
              onChange={cmntOnChange}
              onInput={onInput}
              onCompositionEnd={onCompositionEnd}
              maxLength={maxLength}
              placeholder={placeholder}
              rows={rows}
              cols={cols}
              inValid={inValid}
            />
            <div className='word-count'>{wordCount}</div>
            <span className='errArea'>
              <PcErrorArea position={errPosition} message={errMessage} />              
            </span>
          </div>
        </div>
      </div>
    </div>

  );
};

export default SpAccordionTextArea;